/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import ResponsiveTable from "../../components/ResponsiveTable";
import { Checkbox, Button, Form, message, Modal } from "antd";
import TableLineIcons from "../../components/TableLineIcons";
import GenericModal from "../../components/GenericModal";
import GenericForm from "../../components/GenericForm";
import TableIDs from "../../data/TableIDs";
import moment from "moment";
import SelfServiceSpecialPagesView from "./SelfServiceSpecialPagesView";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import { User, Job, OutputType, ProcessType } from "../../JmReact";


class SelfServiceSpecialPages extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            sorter: { field: "_PosName", order: "ascend" },
            filterText: "",
            modalDates: null,
        };

        this.id = "SELF_SERVICE_SPECIAL_PAGES";

        this.api = {
            get: "get_self_service_special_pages",
            create: "create_self_service_special_pages",
            edit: "edit_self_service_special_pages",
            delete: "delete_self_service_special_pages",

            selectorPage: "get_button_layout_pages_list",

        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        if (props.data[TableIDs.genericSelectorButtonPage] === undefined) props.data[TableIDs.genericSelectorButtonPage] = { ...props.data.genericSelector };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.refreshData()
    }

    componentDidUpdate(p) {
        document.title = "Cash On Tab - " + this.getText(21145);

        let prevPos = p.data[this.id].editedRecord._PosID
        let curPos = this.props.data[this.id].editedRecord._PosID

        if (prevPos !== curPos) this.refreshPages(curPos)
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    refreshPages = (mPOSID) => {
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.genericSelectorRefreshDataset,
            args: [TableIDs.genericSelectorButtonPage, this.props.user.companyCode, this.props.user.token, this.api.selectorPage, { mPOSID }]
        });
    }

    getDataSource = () => {
        const { sorter, filterText } = this.state;
        const { data, headers } = this.props.data[this.id]
        let field = sorter.field ?? "_PosName"
        let order = sorter.order ?? "ascend"
        return data.map((x, index) => {
            if (filterText && x.indexOf(filterText) == -1) return null;
            let y = x.split("\f")
            let res = { key: y[0], index }
            headers.forEach((z, i) => { res = { ...res, [z]: y[i] } })
            return res
        })
        .filter(f => f )
        .sort((a, b) => {
            return (order == "ascend") ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field])
        })
    }

    renderEditCol = (t, record) => {
        return (<TableLineIcons
            onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index) }}
            onDelete={() => { this.props.dataActions.genericDataDeleteRow(this.id, record.key, this.props.user.companyCode, this.props.user.token, this.api.delete, this.api.get) }}
            deleteQuetion={{ title: this.getText(21994), okText: this.getText(21995), cancelText: this.getText(21996) }}
            genericIcons={[
                {
                    type: 'calendar',
                    onClick: () => { this.setState({ modalDates: record }) },
                    tooltip: this.getText(22003),
                    color: record._Date1 || record._Date2 || record._Date3 || record._Date4 || record._Date5 ? "red" : "black",
                }, {
                    type: "copy",
                    onClick: () => { this.setState({ modalCopy: record.key, modalCopyTargetPosList: "" }) },
                    tooltip: this.getText(22873),
                }
            ]}
        />)
    }

    handleCancel = () => {
        if (this.props.data[this.id].editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
        else this.props.dataActions.genericDataCancelEditing(this.id);
    }

    handleOk = () => {
        const { data, headers, editedRecord } = this.props.data[this.id]
        const { _PosID, _StartPageNum } = editedRecord
        if (!_PosID || !_StartPageNum) {
            message.error(this.getText(21162))
        } else {
            const saveData = () => {
                let script = this.props.data[this.id].editing == 0 ? this.api.create : this.api.edit
                this.props.dataActions.genericDataSaveEdit(this.id, this.props.user.companyCode, this.props.user.token, script, this.api.get);
            }

            let findSimilar = data.map((x, index) => {
                let y = x.split("\f")
                let res = { key: y[0], index }
                headers.forEach((z, i) => { res = { ...res, [z]: y[i] } })
                return res
            }).find(f => {
                let isOverlap = f.key != editedRecord.key && f._PosID == editedRecord._PosID
                if (f._CustTagID && editedRecord._CustTagID && f._CustTagID != editedRecord._CustTagID) isOverlap = false
                if (this.getTimeSec(f._FromHour) > this.getTimeSec(editedRecord._ToHour, true)) isOverlap = false
                if (this.getTimeSec(editedRecord._FromHour) > this.getTimeSec(f._ToHour, true)) isOverlap = false
                if (!f._DaysOfWeek || !editedRecord._DaysOfWeek || !f._DaysOfWeek.split(",").find(ff => editedRecord._DaysOfWeek.indexOf(ff) > -1)) isOverlap = false
                return isOverlap
            })

            if (findSimilar) {
                Modal.confirm({
                    content: (<h4>
                        {this.getText(21165)} {findSimilar._PosName}<br />
                        {this.getText(findSimilar._CustTagName ? 21167 : 21166)} {findSimilar._CustTagName}<br />
                        {this.getText(21168)} {this.renderHour(findSimilar._FromHour)} -  {this.renderHour(findSimilar._ToHour)}<br />
                        {this.getText(21169)} {this.renderDays(findSimilar._DaysOfWeek)}<br />
                        {this.getText(21170)}
                    </h4>),
                    iconType: 'exclamation-circle',
                    okText: this.getText(21171),
                    cancelText: this.getText(21172),
                    onOk: saveData,
                    onCancel() { },
                })
            } else {
                saveData()
            }
        }
    }

    handleCopy = () => {
        if (this.state.modalCopy && this.state.modalCopyTargetPosList) {
            this.sendAPI("copy_self_service_special_pages", {
                _id: this.state.modalCopy,
                _targetPosList: this.state.modalCopyTargetPosList,
            }, (ob) => {
                const [_status, _message] = ob.data ? ob.data.split("\f") : ["1", " - "];
                if (_status > 0) {
                    message.error(_message)
                } else {
                    this.setState({ modalCopy: null, modalCopyTargetPosList: "" }, () => {
                        message.success(_message)
                        this.refreshData()
                    })
                }
            });
        }
    }

    handleSaveDates = () => {
        if (this.state.modalDates) {

            this.props.dataActions.genericDataSaveEditWithParams(
                this.id,
                this.props.user.companyCode,
                this.props.user.token,
                this.api.edit,
                this.api.get,
                this.state.modalDates
            );

            this.setState({ modalDates: null })
        }
    }

    sendAPI = (script, data, sCall) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCall, e => { console.error(e) });
    };

    getTimeSec = (time, to) => {
        return (!time) ? (to ? 60 * 60 * 24 : 0) : moment.duration(time).asSeconds()
    }

    createNew = () => {
        this.props.dataActions.genericDataStartInlineCreate(this.id)
        setTimeout(() => {
            this.props.dataActions.genericDataSetEdit(this.id, {
                _FromHour: "00:00:00",
                _ToHour: "23:59:59",
                _DaysOfWeek: "1,2,3,4,5,6,7",
                _IsActive: "1"
            })
        }, 100);
    }

    renderHour = (t) => t ? t.split(":").slice(0, 2).join(":") : "";
    renderDays = (t) => t ? t.split(",").map(x => ' אבגדהוז'.split('')[x]).join(",") : "";

    renderPage = (t, r, k) => {
        return (<div style={{ textAlign: "right" }}>
            <SelfServiceSpecialPagesView
                {...this.props}
                posId={r._PosID}
                posName={r._PosName}
                pageId={r[k]} />
            {t}
        </div>)
    }

    render() {
        const gt = this.getText;
        const { editing, editedRecord } = this.props.data[this.id]
        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        let sorter = true;
        let render = t => t;

        let numOfRowsByHeight = parseInt((window.innerHeight - 400 > 30) ? (window.innerHeight - 400) / 30 : 1);


        return (<div style={divStyle}>
            <ResponsiveTable
                dataSource={this.getDataSource()}
                rowsFilter={r => r.key > 0}
                title={gt(21145)}
                columns={[
                    { title: gt(21146), key: "_PosName", dataIndex: "_PosName", sorter, render },
                    { title: gt(21147), key: "_CustTagName", dataIndex: "_CustTagName", sorter, render },
                    { title: gt(21997), key: "_Desc", dataIndex: "_Desc", sorter, render },
                    { title: gt(21148), key: "_FromHour", dataIndex: "_FromHour", sorter, render: this.renderHour },
                    { title: gt(21149), key: "_ToHour", dataIndex: "_ToHour", sorter, render: this.renderHour },
                    { title: gt(21150), key: "_DaysOfWeek", dataIndex: "_DaysOfWeek", sorter, render: this.renderDays },
                    { title: gt(21151), key: "_StartPageName", dataIndex: "_StartPageName", sorter, render: (t, r) => this.renderPage(t, r, '_StartPageNum') },
                    { title: gt(21152), key: "_SidePageName", dataIndex: "_SidePageName", sorter, render: (t, r) => this.renderPage(t, r, '_SidePageNum') },
                    { title: gt(21153), key: "_IsActive", dataIndex: "_IsActive", sorter, render: t => (<Checkbox checked={t == 1} disabled />) },
                    { title: gt(21154), render: this.renderEditCol },
                ]}
                actionButtons={[{
                    buttonType: 'add',
                    buttonFunction: this.createNew
                }, {
                    buttonType: 'refresh',
                    buttonFunction: this.refreshData
                }]}
                pagination={{ pageSize: numOfRowsByHeight }}
                onChange={(p, f, sorter) => { this.setState({ sorter }) }}
                showsearch={filterText => { this.setState({ filterText }) }}
            />

            <GenericModal
                visible={editing > -1}
                onCancel={this.handleCancel}
                title={gt(21155)}
                width={1200}
                footer={[
                    <Button key={"back"} onClick={this.handleCancel} style={{ margin: 5 }}>{gt(21156)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleOk} style={{ margin: 5 }}>{gt(21157)}</Button>,
                ]}>
                <GenericForm
                    columnCount={3}
                    value={editedRecord}
                    onChange={obj => { this.props.dataActions.genericDataSetEdit(this.id, obj) }}
                    fields={[
                        { label: gt(21146), key: "_PosID", inputType: "posSelector", inputProps: this.props, isMandatory: true },
                        { label: gt(21147), key: "_CustTagID", inputType: "custTagSelector", inputProps: this.props, },
                        { label: gt(21997), key: "_Desc", inputType: "textarea", inputProps: this.props, isMandatory: false },
                        { label: gt(21148), key: "_FromHour", inputType: "time" },
                        { label: gt(21149), key: "_ToHour", inputType: "time" },
                        { label: gt(21150), key: "_DaysOfWeek", inputType: "daysOfWeek" },
                        { label: gt(21151), key: "_StartPageNum", inputType: "selector", inputProps: { ...this.props, id: TableIDs.genericSelectorButtonPage }, isMandatory: true },
                        { label: gt(21152), key: "_SidePageNum", inputType: "selector", inputProps: { ...this.props, id: TableIDs.genericSelectorButtonPage } },
                        { label: gt(21153), key: "_IsActive", inputType: "checkbox" },
                    ]}
                />
            </GenericModal>
            <GenericModal
                visible={this.state.modalDates != null}
                onCancel={() => { this.setState({ modalDates: null }) }}
                title={gt(22003)}
                width={500}
                footer={[
                    <Button key={"back"} onClick={() => { this.setState({ modalDates: null }) }} style={{ margin: 5 }}>{gt(21156)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleSaveDates} style={{ margin: 5 }}>{gt(21157)}</Button>,
                ]}>
                {this.state.modalDates ?
                    <GenericForm
                        columnCount={1}
                        value={this.state.modalDates}
                        onChange={obj => { this.setState({ modalDates: { ...this.state.modalDates, ...obj } }) }}
                        fields={[
                            { label: gt(21998), key: "_Date1", inputType: "date" },
                            { label: gt(21999), key: "_Date2", inputType: "date" },
                            { label: gt(22000), key: "_Date3", inputType: "date" },
                            { label: gt(22001), key: "_Date4", inputType: "date" },
                            { label: gt(22002), key: "_Date5", inputType: "date" },
                        ]}
                    />
                    : ""}
            </GenericModal>
            <GenericModal
                visible={this.state.modalCopy != null}
                onCancel={() => { this.setState({ modalCopy: null }) }}
                title={gt(22873)}
                width={500}
                footer={[
                    <Button key={"back"} onClick={() => { this.setState({ modalCopy: null }) }} style={{ margin: 5 }}>{gt(22875)}</Button>,
                    <Button key={"create"} type={"primary"} onClick={this.handleCopy} style={{ margin: 5 }}>{gt(22874)}</Button>,
                ]}>
                <Form.Item label={gt(22876)}>
                    <GenericSelectorPosStorages {...this.props} multi
                        value={this.state.modalCopyTargetPosList ? this.state.modalCopyTargetPosList.split(",") : []}
                        onChange={value => { this.setState({ modalCopyTargetPosList: value ? value.join(",") : "" }) }}
                    />
                </Form.Item>

            </GenericModal>
        </div>)
    }

}

export default SelfServiceSpecialPages;